var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-simplebar',{staticClass:"body",class:{'nopadding': _vm.nopadding, 'is-text': _vm.type === 'text', 'nofoot': _vm.nofoot},attrs:{"trackScroll":_vm.trackScroll,"initialScroll":_vm.initialScroll},on:{"scroll":function($event){return _vm.$emit('scroll', $event)}}},[_c('div',{staticClass:"body-inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }